import Games from './Games';
import Game from './scenes/Game';
import Title from './scenes/title/Title';

export const GAME_CONFIGS = {
  [Games.alphabet]: {
    GAME_NAME: 'Fridge Magnets',
    ELESE: 1,

    NORMAL_INTRO_OFFSETY: 240,
    WIDE_INTRO_OFFSETY: 160,

    FLIPS: false,
    BASE_ITEM_INDEX: -1,
    BASE_ITEM_YOFFSET: 0,
    SUBMENU_WIDTH: 400,

    MIN_ITEMWIDTH: 40,
    MIN_ITEMHEIGHT: 50,

    DROP_BG_LOCS: { nx: 480,ny: 60,wx: 470,wy: 30 },

    MENU_COLORS: ['0xffea83','0xafe823','0xffa300','0x88ffff','0xa04db3'],
    ANIMATED_MENUS: [],
    PARTICLE_TYPE: '',
    PARTICLE_SPAWN_COUNT: 0,
    PARTICLE_WAITER: 1,
    PARTICLE_END_OFFSET: 0,

    EXTRA_SOUNDS: [{ path: 'symbols/', manifest: [] }, { path: 'numbers/', manifest: [] }, { path: 'letters/', manifest: [] }]
  },
  [Games.face]: {
    GAME_NAME: 'Make A Face',
    ELESE: 1,
    NORMAL_INTRO_OFFSETY: 120,
    WIDE_INTRO_OFFSETY: 20,

    BASE_ITEM_COUNT: 6,
    BASE_ITEM_INDEX: 7,
    BASE_ITEM_YOFFSET: 0,
    SUBMENU_WIDTH: 200,
    ITEM_SHEET_COUNT: 2,

    MIN_ITEMWIDTH: 40,
    MIN_ITEMHEIGHT: 50,
    FLIPS: true,
    FLIP_MENUS: [true, true,true,true,true,true],

    DROP_BG_LOCS: { nx: 300,ny: 30,wx: 230,wy: 20 },

    MENU_COLORS: ['0xFF0000','0x38CFE8','0x8AC622','0xFF7900','0x9500FF','0x5191ED','0xFFFF00','0x002068'],
    HAS_ANIMATED: true,
    ANIMATED_MENUS: [1],
    ANIMATION_REG_OFFSET: 167,
    PARTICLE_TYPE: '',
    PARTICLE_SPAWN_COUNT: 0,
    PARTICLE_WAITER: 1,
    PARTICLE_END_OFFSET: 0
  },
  [Games.gingerbread]: {
    GAME_NAME: 'Build A Gingerbread House',
    ELESE: 1,
    NORMAL_INTRO_OFFSETY: 120,
    WIDE_INTRO_OFFSETY: 20,

    HAS_BASE_ITEM: true,
    BASE_ITEM_INDEX: -1,
    BASE_ITEM_COUNT: 1,
    BASE_ITEM_YOFFSET: 40,
    SUBMENU_WIDTH: 200,

    MIN_ITEMWIDTH: 40,
    MIN_ITEMHEIGHT: 50,

    FLIPS: true,
    FLIP_MENUS: [true, true,true,true,true,true],

    DROP_BG_LOCS: { nx: 300,ny: 30,wx: 230,wy: 10 },

    MENU_COLORS: ['0x933100','0x38CFE8','0x8AC622','0x185F9E','0x9500FF','0x5191ED'],

    ANIMATED_MENUS: [1],

    PARTICLE_TYPE: 'Cloud',
    PARTICLE_SETTINGS: { movement: 1,
      spawnCount: 1,
      typeCount: 3,
      waiter: 4888,
      waiterMin: 4500,
      waiterMax: 12500,
      endoffset: 15,
      minSpeed: 20,
      maxSpeed: 45,
      locRanges: [{ min: 2,max: 240 }] }
  },
  [Games.pumpkin]: {
    GAME_NAME: 'Make A Pumpkin',
    ELESE: 1,
    NORMAL_INTRO_OFFSETY: 120,
    WIDE_INTRO_OFFSETY: 20,

    HAS_BASE_ITEM: true,
    BASE_FROM_BOTTOM: true,
    BASE_ITEM_INDEX: 0,
    BASE_ITEM_COUNT: 4,
    BASE_ITEM_YOFFSET: -30,
    SUBMENU_WIDTH: 200,

    FLIPS: true,
    FLIP_MENUS: [true, true,true,true,true,true],

    MIN_ITEMWIDTH: 40,
    MIN_ITEMHEIGHT: 50,

    DROP_BG_LOCS: { nx: 300,ny: 30,wx: 230,wy: 10 },

    MENU_COLORS: ['0x00629e','0xffb600','0x80b715','0xff7900','0x9500ff','0x5191ed'] ,

    HAS_ANIMATED: true,
    ANIMATED_MENUS: [2],
    ANIMATION_REG_OFFSET: 130,

    PARTICLE_TYPE: '',
    PARTICLE_SETTINGS: {}
  },
  [Games.snowman]: {
    GAME_NAME: 'Make a snowman',
    ELESE: 1,
    NORMAL_INTRO_OFFSETY: 120,
    WIDE_INTRO_OFFSETY: 20,

    HAS_BASE_ITEM: true,
    BASE_ITEM_INDEX: -1,
    BASE_ITEM_YOFFSET: 40,
    SUBMENU_WIDTH: 200,

    MIN_ITEMWIDTH: 40,
    MIN_ITEMHEIGHT: 40,

    FLIPS: true,
    FLIP_MENUS: [true, true,true,true,true,true],

    DROP_BG_LOCS: { nx: 300,ny: 30,wx: 230,wy: 20 },

    MENU_COLORS: ['0xFFD400','0xBBF9FF','0xB5E51F','0x0055AA','0x9500FF'],
    HAS_ANIMATED: true,
    ANIMATED_MENUS: [1],
    ANIMATION_REG_OFFSET: 55,

    PARTICLE_TYPE: 'Snowflake',
    PARTICLE_SETTINGS: { movement: 0,
      spawnCount: 1,
      typeCount: 5,
      waiter: 888,
      endoffset: 15,
      minSpeed: 35,
      maxSpeed: 100,
      locRanges: [{ min: 40,max: 500 }] },

    PARTICLE_SPAWN_COUNT: 1,
    PARTICLE_TYPE_COUNT: 5,
    PARTICLE_WAITER: 888,
    PARTICLE_END_OFFSET: 15
  },
};

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Title, Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Title.KEY,

  MUSIC_ON: true,
  game: Games.alphabet,
  settings: GAME_CONFIGS[Games.alphabet]
};